/* A finished square follows a service changed on the booking afterwards.
 *
 * Kevin, 2026-10-23: Thu's 12:20 Walk In was booked as a Pamper Me Pedicure and
 * a Classic Manicure. Thu finished the pedicure at 1:11; at 1:15 the desk
 * corrected the booking to the Classic Pedicure she had actually done. The
 * board has to match Mangomint, but the swap pass only moved running squares,
 * so the square went on reading Pamper Me — and the new Classic Pedicure line,
 * with nothing holding it, was folded onto that same square as if it had been
 * sold at the chair.
 *
 * A finished square is the record of the work, and a booking corrected after
 * the fact is the desk correcting that record, so until the day is closed the
 * square follows it. The join has nothing to go on but the visit, so all of it
 * has to hold:
 *
 *   - its own line is gone from the book (the caller only asks then);
 *   - the line is on the same appointment and booked with this technician;
 *   - nothing else holds it — another square, or another square's folded
 *     add-on. One folded onto THIS square is the mistake above, and is fine;
 *   - it is the same side of the client, when both sides are known: a
 *     pedicure corrected into a pedicure, never into the visit's manicure.
 *
 * Nearest booked start wins, the same tie-break as everywhere else.
 *
 * Pure.
 *   turn        { startedAt }
 *   side        the square's turn type's side ('feet' | 'hands' | null)
 *   candidates  [{ id, startsAt, side, onTech, held }] — the visit's lines;
 *               `held` true when another square or its add-on has the line
 * Returns the id of the line to follow, or null.
 */
export function finishedSwapLine(turn, side, candidates) {
  var ok = (candidates || []).filter(function (c) {
    if (!c || !c.onTech || c.held) return false;
    return !side || !c.side || c.side === side;
  });
  if (!ok.length) return null;
  var at = turn && turn.startedAt != null ? turn.startedAt : 0;
  ok.sort(function (a, b) {
    return Math.abs((a.startsAt || 0) - at) - Math.abs((b.startsAt || 0) - at);
  });
  return ok[0].id;
}
